<template>
  <el-select
    v-model="source"
    placeholder="เลือกประเภททรัพย์สิน"
    :disabled="disabled"
  >
    <el-option
      v-for="item in optionList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { Option as ElOption, Select as ElSelect } from "element-ui";
import { SellAndRentSource } from "../SellAndRentSource";

export default {
  components: {
    ElOption,
    ElSelect
  },
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  computed: {
    source: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    optionList() {
      // "ทั้งหมด" (value "") is the default; the rest come from the source enum
      return [
        { value: "", label: "ทั้งหมด" },
        ...Object.keys(SellAndRentSource).map(value => ({
          value,
          label: SellAndRentSource[value]
        }))
      ];
    }
  }
};
</script>
